import { AsyncPipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core'
import { MatIconButton } from '@angular/material/button'
import { MatChip, MatChipSet } from '@angular/material/chips'
import { MatFormField, MatLabel } from '@angular/material/form-field'
import { MatIcon } from '@angular/material/icon'
import { MatInput } from '@angular/material/input'
import { MatMenu, MatMenuTrigger } from '@angular/material/menu'
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
} from '@angular/material/table'
import {
  ElderBasicPaneLayoutComponent,
  ElderFormFieldLabelDirective,
  ElderPaneActionsComponent,
  ElderPaneComponent,
  ElderPaneContentComponent,
  ElderPaneHeaderComponent,
  ElderPaneTitleComponent,
  ElderQuantityPipe,
  ElderTableComponent,
  ElderToastService,
} from '@elderbyte/ngx-starter'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { BehaviorSubject } from 'rxjs'
import { Delivery } from '../../../delivery/delivery'
import { DeliveryService } from '../../../delivery/delivery.service'
import { ProdOrder } from '../../prod-order'

@Component({
  selector: 'app-prod-order-detail',
  templateUrl: './prod-order-detail.component.html',
  styleUrls: ['./prod-order-detail.component.scss'],
  imports: [
    MatIconButton,
    MatMenuTrigger,
    MatIcon,
    MatMenu,
    MatFormField,
    ElderFormFieldLabelDirective,
    MatLabel,
    MatInput,
    MatChipSet,
    MatChip,
    ElderTableComponent,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    AsyncPipe,
    ElderTranslatePipe,
    ElderQuantityPipe,
    ElderBasicPaneLayoutComponent,
    ElderPaneComponent,
    ElderPaneContentComponent,
    ElderPaneTitleComponent,
    ElderPaneHeaderComponent,
    ElderPaneActionsComponent,
  ],
})
export class ProdOrderDetailComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public readonly order$ = new BehaviorSubject<ProdOrder>(null)
  public readonly deliveries$ = new BehaviorSubject<Delivery[]>([])
  private deliveryService = inject(DeliveryService)
  private toastService = inject(ElderToastService)

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  @Input()
  public set order(order: ProdOrder) {
    this.order$.next(order)
    this.loadDeliveries(order)
  }

  /***************************************************************************
   *                                                                         *
   * Private methods                                                         *
   *                                                                         *
   **************************************************************************/

  private loadDeliveries(order: ProdOrder): void {
    if (order) {
      this.deliveryService.findAllOrderReference(order.id).subscribe({
        next: (deliveries) => this.deliveries$.next(deliveries),
        error: (err) => this.toastService.error('Failed to load deliveries', err),
      })
    } else {
      this.deliveries$.next([])
    }
  }
}
